var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMizug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#91D9BF",
    d: "M23.754 17.79h-.42c.014-.074.023-.152.023-.232V1.128c0-.622-.488-1.128-1.09-1.128H2.446c-.6 0-1.089.506-1.089 1.129v16.43c0 .08.008.157.024.231H.96c-.53 0-.96.446-.96.994 0 .55.43.994.96.994h22.794c.53 0 .96-.444.96-.994 0-.548-.43-.994-.96-.994",
    transform: "translate(.13 .632)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36947D",
    d: "M19.296 9.754c0 3.972-3.107 7.191-6.94 7.191-3.832 0-6.939-3.22-6.939-7.191 0-3.972 3.107-7.191 6.94-7.191 3.832 0 6.939 3.22 6.939 7.191",
    transform: "translate(.13 .632)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91D9BF",
    d: "M15.475 8.283h-1.693V3.586c-1.57 0-2.84 1.317-2.84 2.943v1.754H6.398c0 1.625 1.27 2.943 2.84 2.943h1.692v4.697c1.569 0 2.84-1.318 2.84-2.943v-1.754h4.543c0-1.626-1.27-2.943-2.84-2.943",
    transform: "translate(.13 .632)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36947D",
    d: "M13.776 9.754c0 .813-.635 1.472-1.42 1.472-.784 0-1.42-.66-1.42-1.472 0-.813.636-1.471 1.42-1.471.785 0 1.42.658 1.42 1.471M21.614 1.868h-1.648c-.114 0-.206-.095-.206-.214 0-.118.092-.214.206-.214h1.648c.115 0 .207.096.207.214 0 .119-.092.214-.207.214M21.614 2.777h-1.648c-.114 0-.206-.095-.206-.214 0-.118.092-.214.206-.214h1.648c.115 0 .207.096.207.214 0 .119-.092.214-.207.214M21.614 3.686h-1.648c-.114 0-.206-.095-.206-.214 0-.118.092-.214.206-.214h1.648c.115 0 .207.096.207.214 0 .12-.092.214-.207.214",
    transform: "translate(.13 .632)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCF040",
    d: "M13.36 9.754c0 .574-.449 1.04-1.003 1.04-.555 0-1.004-.466-1.004-1.04 0-.574.449-1.04 1.004-1.04.554 0 1.003.466 1.003 1.04",
    transform: "translate(.13 .632)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMizug);
export default __webpack_public_path__ + "static/media/mizug.9a24595731fffbb0e116a7e9b6c6c232.svg";
export { ForwardRef as ReactComponent };